import Dashboard from '@desktop/components/Dashboard.vue';
import Record from '@desktop/components/Record.vue';
import RecordOverview from '@desktop/components/record/Overview.vue';
import RecordCustomer from '@desktop/components/record/Customer.vue';
import RecordVehicle from '@desktop/components/record/Vehicle.vue';
import RecordAccidentDocumentation from '@desktop/components/record/AccidentDocumentation.vue';
import RecordParticipants from '@desktop/components/record/Participants.vue';
import RecordDocuments from '@desktop/components/record/Documents.vue';
import RecordNotes from '@desktop/components/record/Notes.vue';
import RecordCompany from '@desktop/components/record/Company.vue';
import RecordCostUnits from '@desktop/components/record/CostUnits.vue';
import AppraisalDetail from '@desktop/views/record/AppraisalDetail.vue';
import RecordCreateSuccess from '@desktop/views/record/CreateSuccess.vue';
import FirmBranchUserAssignment from '@desktop/components/firm/FirmBranchUserAssignment.vue';
import FirmCreate from '@desktop/components/firm/FirmCreate.vue';
import FirmDetails from '@desktop/components/firm/FirmDetails.vue';
import FirmSpecificDocumentDetail from '@desktop/components/firm/firmSpecificDocument/FirmSpecificDocumentDetail.vue';
import FirmSpecificDocumentCreate from '@desktop/components/firm/firmSpecificDocument/FirmSpecificDocumentCreate.vue';
import FirmSpecificDocuments from '@desktop/components/firm/FirmSpecificDocuments.vue';
import FirmInvoicingModalities from '@desktop/components/firm/invoicingModality/FirmInvoicingModalities.vue';
import RecordRepair from '@desktop/components/record/Repair.vue';
import ReceiptEntries from '@desktop/views/record/ReceiptEntries.vue';
import RecordFees from '@desktop/components/record/Fees.vue';
import FirmGroupDetails from '@desktop/components/firmGroup/FirmGroupDetails.vue';
import FirmGroupInvoicingModalities
    from '@desktop/components/firmGroup/invoicingModality/FirmGroupInvoicingModalities.vue';
import FirmGroupCreate from '@desktop/components/firmGroup/FirmGroupCreate.vue';
import AnnouncementCreate from '@desktop/views/Announcement/AnnouncementCreate.vue';
import AnnouncementDetail from '@desktop/views/Announcement/AnnouncementDetail.vue';
import AnnouncementList from '@desktop/views/Announcement/AnnouncementList.vue';
import DigitalMailboxEmailList from '@desktop/views/digitalMailbox/DigitalMailboxEmailList.vue';
import FirmAssociationDocuments from '@desktop/components/firmAssociation/FirmAssociationDocuments.vue';
import ResellerDocuments from '@desktop/components/reseller/ResellerDocuments.vue';
import TuevSuedStatus from '@desktop/views/tuevSued/TuevSuedStatus.vue';

export default [
    {
        path: '/de/Schaden-Manager/Akte/Detail/vehicleDamageRecordId/:recordId',
        component: Record,
        props: true,
        children: [
            {path: '', name: 'overviewRoute', component: RecordOverview, props: true},
            {
                path: 'customer',
                name: 'customerRoute',
                component: RecordCustomer,
            },
            {
                path: 'vehicle',
                name: 'vehicleRoute',
                component: RecordVehicle,
            },
            {
                path: 'repair',
                name: 'repairRoute',
                component: RecordRepair,
            },
            {
                path: 'accident-documentation',
                name: 'accidentDocumentationRoute',
                component: RecordAccidentDocumentation,
            },
            {
                path: 'participants',
                name: 'participantsRoute',
                component: RecordParticipants,
            },
            {
                path: 'documents',
                name: 'documentsRoute',
                component: RecordDocuments,
            },
            {
                path: 'notes',
                name: 'notesRoute',
                component: RecordNotes,
            },
            {
                path: 'cost-units',
                name: 'costUnitsRoute',
                component: RecordCostUnits,
            },
            {
                // Nested under cost-units so the "Forderungen" tab stays visually active
                // (both via router-link-active prefix matching and the legacy highlightNavLinks() logic).
                path: 'cost-units/appraisals/:appraisalId',
                name: 'appraisalDetailRoute',
                component: AppraisalDetail,
            },
            {
                path: 'fees',
                name: 'feesRoute',
                component: RecordFees,
            },
            {
                path: 'receiptentries',
                name: 'receiptentriesRoute',
                component: ReceiptEntries,
            },
            {path: 'company', name: 'companyRoute', component: RecordCompany},
        ],
    },
    {
        path: '/de/Schaden-Manager/Akte/Schnellerfassung/success/:recordId',
        component: RecordCreateSuccess,
        name: 'record-create-success', // name required by RecordCreateMixin.vue
    },
    {
        path: '/de/Schaden-Manager/Firma/firmBranchUserAssignment/firmId/:firmId',
        component: FirmBranchUserAssignment,
        props: true,
    },
    {
        path: '/de/Schaden-Manager/Firma/Anzeigen/firmId/:firmId',
        component: FirmDetails,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Firma/Neu',
        component: FirmCreate,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Firma/firm-specific-documents/firmId/:firmId',
        component: FirmSpecificDocuments,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Firma/firm-specific-documents/firmId/:firmId/Detail/firmSpecificDocumentId/:firmSpecificDocumentId',
        component: FirmSpecificDocumentDetail,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Firma/firm-specific-documents/firmId/:firmId/Create',
        component: FirmSpecificDocumentCreate,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Firma/invoicingModalities/firmId/:firmId',
        component: FirmInvoicingModalities,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/firmgroup/Detail/firmGroupId/:firmGroupId',
        component: FirmGroupDetails,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/firmgroup/invoicingModalities/firmGroupId/:firmGroupId',
        component: FirmGroupInvoicingModalities,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/firmgroup/Neu',
        component: FirmGroupCreate,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Dokument/announcements',
        component: AnnouncementList,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Dokument/announcements/show/:announcementId',
        component: AnnouncementDetail,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Dokument/announcements/create',
        component: AnnouncementCreate,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/firmassociation/Dokumente/firmAssociationId/:firmAssociationId',
        component: FirmAssociationDocuments,
        props: false,
    },
    {
        path: '/de/Schaden-Manager',
        component: Dashboard,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/resellerdocument',
        component: ResellerDocuments,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Digitale-Mailbox',
        component: DigitalMailboxEmailList,
        props: false,
    },
    {
        path: '/de/Schaden-Manager/Dokument/tuevsuedstatus',
        component: TuevSuedStatus,
        props: false,
    },
];
